export default class {
  constructor (form) {
    // This.form = form
    this.formFields = form.querySelector('div').nextElementSibling
    this.agreementFields = this.formFields.nextElementSibling
  }

  get user () {
    return this.formFields.querySelectorAll('.form-group').map((el, i) => ({
      id: i,
      enabled: true,
      el: el.querySelector('.form-control'),
      value: el.querySelector('.form-control').value,
    }))
  }

  set user (fields) {
    this.formFields.querySelectorAll('.form-group').forEach((el, i) => {
      const input = el.querySelector('.form-control')

      if (i == 0) input.value = fields.firstName
      else if (i == 1) input.value = fields.lastName
      else if (i == 2) input.value = fields.email
      else if (i == 3) input.value = fields.phoneNumber
      else return
    })
  }

  get checklist () {
    return this.agreementFields.querySelectorAll('.form-group').map((el, i) => ({
      id: i,
      enabled: true,
      name: this.agreementText(el),
      selected: el.querySelector('.checkbox input[type="checkbox"]').checked,
      required: this.isRequired(el),
      html: true,
    }))
  }

  set checklist (fields) {
    this.agreementFields.querySelectorAll('.form-group').forEach((el, i) => {
      const input = el.querySelector('.checkbox input[type="checkbox"]')
      
      if (fields[i].selected) {
        input.setAttribute('checked', '')
        input.value = true
      } else {
        input.removeAttribute('checked')
        input.value = false
      }
    })
  }

  isRequired (el) {
    return !!(el.classList && el.classList.length && el.classList.contains('required-field'))
  }

  agreementText (el) {
    const helpBlock = el.querySelector('.help-block:not(.field-validation-valid)')
    return helpBlock ? helpBlock.innerHTML : ''
  }
}


// WEBPACK FOOTER //
// ./src/services/RodoWFFMDataExchange.js